import Chevron from 'src/components/dashboard/components/navigationMenu/components/chevron';
import { formatDate } from 'src/utils/formatDate';
import { formatMoney } from 'src/utils/formatMoney';
import { PaymentHisotryTableData } from 'src/services/models/payment.service';
import { useLocalization } from 'src/utils/useLocalization';
import { Dispatch, SetStateAction } from 'react';

import './style.scss';

export interface ITableContents {
    items: PaymentHisotryTableData[];
    sortType: string;
    sortOrder: boolean;
    setSortType: Dispatch<SetStateAction<string>>;
    setSortOrder: Dispatch<SetStateAction<boolean>>;
}

export interface PaymentHistoryTableItemData {
    data: PaymentHisotryTableData;
}

export const TableItem: React.FC<PaymentHistoryTableItemData> = ({ data }) => {
    const {
        processDate,
        accountType,
        paymentStatus,
        account,
        amount,
        paymentReason,
        comment,
        userName,
    } = data;

    const {
        paymentHistory,
        paymentAccountEnumToUi,
        paymentStatusEnumToUi,
        paymentReasonEnumToUi,
    } = useLocalization();
    return (
        <div className='row'>
            <div className='table-row col-1'>
                <span className='list-label'>{paymentHistory.TABLE_DATE}</span>
                <span>{formatDate(processDate.toDateString())}</span>
            </div>
            <div className='table-row col-2'>
                <span className='list-label'>{paymentHistory.TABLE_TYPE}</span>
                <span>{paymentAccountEnumToUi[accountType]}</span>
            </div>
            <div className='table-row col-3'>
                <span className='list-label'>
                    {paymentHistory.TABLE_STATUS}
                </span>
                <span>{paymentStatusEnumToUi[paymentStatus]}</span>
            </div>
            <div className='table-row col-4'>
                <span className='list-label'>
                    {paymentHistory.TABLE_ACCOUNT}
                </span>
                <span>{account}</span>
            </div>
            <div className='table-row col-5'>
                <span className='list-label'>
                    {paymentHistory.TABLE_AMOUNT}
                </span>
                <span>{formatMoney(amount)}</span>
            </div>
            <div className='table-row col-6'>
                <span className='list-label'>
                    {paymentHistory.TABLE_REASON}
                </span>
                <span>{paymentReasonEnumToUi[paymentReason]}</span>
            </div>
            <div className='table-row col-7'>
                <span className='list-label'>
                    {paymentHistory.TABLE_COMMENT}
                </span>
                <span>{comment}</span>
            </div>
            <div className='table-row col-8'>
                <span className='list-label'>{paymentHistory.TABLE_USER}</span>
                <span>{userName.replace(' (not valid in Elvis)', '')}</span>
            </div>
        </div>
    );
};

export const Table: React.FC<ITableContents> = ({
    items,
    sortType,
    sortOrder,
    setSortType,
    setSortOrder,
}) => {
    const chevronColor = '#363b49';
    const { paymentHistory } = useLocalization();

    /**
     * Function to sort based on the property and sort order
     * @param property
     * @param order
     */
    const applySort = (property: string, order = true) => {
        if (sortType == property) {
            setSortOrder(!sortOrder);
        } else {
            setSortType(property);
            setSortOrder(order);
        }
    };

    /**
     * Function to render sorting buttons on table header
     * @param property
     * @param clickhandler
     * @returns
     */
    const renderTableSort = (property: string, clickhandler: any) => (
        <span className='table-header__order'>
            <span
                onClick={() => {
                    clickhandler(property);
                }}
            >
                <Chevron
                    className={`accordion__icon ${
                        sortOrder && sortType == property
                            ? 'rotate-down'
                            : 'rotate-up'
                    }`}
                    width={10}
                    fill={chevronColor}
                />
            </span>
            {sortType != property ? (
                <span
                    onClick={() => {
                        clickhandler(property, false);
                    }}
                >
                    <Chevron
                        className='accordion__icon rotate-down'
                        width={10}
                        fill={chevronColor}
                    />
                </span>
            ) : null}
        </span>
    );
    return (
        <div className='payment-history-table-wrapper'>
            <div className='table' id='payment-history-table'>
                <div className='row header-row hidden-in-list'>
                    <div className='table-header col-1'>
                        <span className='u-text-truncate'>
                            {paymentHistory.TABLE_DATE}
                        </span>
                        {renderTableSort('processDate', applySort)}
                    </div>
                    <div className='table-header col-2'>
                        <span className='u-text-truncate'>
                            {paymentHistory.TABLE_TYPE}
                        </span>
                    </div>
                    <div className='table-header col-3'>
                        <span className='u-text-truncate'>
                            {paymentHistory.TABLE_STATUS}
                        </span>
                    </div>
                    <div className='table-header col-4'>
                        <span className='u-text-truncate'>
                            {paymentHistory.TABLE_ACCOUNT}
                        </span>
                        {renderTableSort('account', applySort)}
                    </div>
                    <div className='table-header col-5'>
                        <span className='u-text-truncate'>
                            {paymentHistory.TABLE_AMOUNT}
                        </span>
                        {renderTableSort('amount', applySort)}
                    </div>
                    <div className='table-header col-6'>
                        <span className='u-text-truncate'>
                            {paymentHistory.TABLE_REASON}
                        </span>
                    </div>
                    <div className='table-header col-7'>
                        <span className='u-text-truncate'>
                            {paymentHistory.TABLE_COMMENT}
                        </span>
                    </div>
                    <div className='table-header col-8'>
                        <span className='u-text-truncate'>
                            {paymentHistory.TABLE_USER}
                        </span>
                    </div>
                </div>
                {items.map((item) => (
                    <TableItem data={item} key={item.key} />
                ))}
            </div>
        </div>
    );
};

export default Table;
